function StaticPageController(){
	this.glob		= ["/page**"];
};
StaticPageController.inheritsFrom( StandardController );
StaticPageController.prototype.on = function(){
	const mapController = new MapController();
};
StaticPageController.prototype.off = function(){};
